import {
  getGetImmaginiAltQueryKey,
  useGetImmaginiAlt,
} from '@framework/api-client/api/inquiries/immagini-controller/immagini-controller.ts';
import { type TipoDomandaDTOCopertina } from '@framework/api-client/api/inquiries/schemas/tipoDomandaDTOCopertina.ts';
import { CoverImageContainer } from '@framework/common-web/ui/inquiry/cover/CoverImageContainer.tsx';
import { useCurrentLocale } from '@framework/i18n/hooks/useCurrentLocale.ts';
import { useEffect } from 'react';
import { queryClient } from '../../../../core/network/queryClient.ts';
import { getImageUrl } from './getImageUrl.tsx';

export interface ICoverImageProps {
  cover?: TipoDomandaDTOCopertina | null;
}

export function CoverImage(props: ICoverImageProps) {
  const { cover } = props;
  const coverImage = cover?.sfondo;

  const locale = useCurrentLocale();

  const alt = useGetImmaginiAlt(
    { ids: [coverImage!] },
    {
      query: { enabled: !!coverImage },
      request: {
        arrayFormat: 'repeat',
      },
    },
  );

  useEffect(() => {
    if (!coverImage) return;
    queryClient.invalidateQueries(
      getGetImmaginiAltQueryKey({ ids: [coverImage] }),
    );
  }, [coverImage, locale.tag]);

  const imageAlt = alt.data?.data?.[0]?.alt ?? 'Immagine';

  return (
    coverImage && (
      <CoverImageContainer>
        <img alt={imageAlt} src={getImageUrl(cover?.sfondo, locale.tag)} />
      </CoverImageContainer>
    )
  );
}
